<template>
    <div class="order__block">
        <div class="mb25">
            <div class="order__tab-wr js-tab">
                <label @click="setTab('list')" class="order__tab-btn" :class="listTabClass" for="tab-list">Списком</label>
                <label @click="setTab('map')" class="order__tab-btn" :class="mapTabClass" for="tab-map">На карте</label>
                <label v-if="pvz_selected.name" class="order__tab-btn terminal_selected">Выбран пункт доставки: {{ pvz_selected.name }} {{ pvz_selected.address }} {{ pvz_selected.worktime }}</label>
                <label v-else class="order__tab-btn terminal_nonselected">Пункт доставки еще не выбран</label>
            </div>
            <div>
                <div v-if="pvz_selected.OnlyPrepaidOrders=='1'">В данном пункте самовывоза <br />выдаются только предоплаченные заказы, <br />при необходимости выберите другой пункт.</div>
            </div>
            <input class="order__radio-tab" id="tab-list" type="radio" name="tab" value="" checked="checked"/>
            <div class="order__tab">
                <input type="text" class="order__input" placeholder="поиск по пунктам выдачи" style="margin-bottom: 15px;" v-model="local_search" />
              <div class="list-loading" v-if="isLoadingList">загрузка пунктов выдачи...</div>
              <div class="list-loading text-danger" v-if="isNoPvz">Не удалось загрузить список, попробуйте обновить страницу.</div>
              <ul v-if="filtered_pvz.length > 0" class="order__pickup-list" style="height: 300px; overflow: auto">
                    <li v-for="pickup in filtered_pvz" class="order__pickup-item">
                        <input
                                v-model="currentTerminal"
                                class="order__radio"
                                :id="pickup.tk_id + ';' + pickup.code"
                                name="pickup"
                                :value="pickup.tk_id + ';' + pickup.code"
                                @change="setPvz()"
                                type="radio"
                        />
                        <label class="order__radio-label" :for="pickup.tk_id + ';' + pickup.code">{{ pickup.name }} {{ pickup.address }} &nbsp;<i v-if="pickup.TripDescription.length" class="fas fa-info-circle" :title="pickup.TripDescription"></i></label>
                        <div class="order__pickup-item-body">
                            <div class="order__pickup-item-metro" style="background: #e6c116"></div>
                            <div class="order__pickup-metro-name">{{ pickup.cost}}р. время работы</div>
                            <div class="order__pickup-time">
                                {{ pickup.worktime }}
                                <span v-if="pickup.OnlyPrepaidOrders=='1'">только предоплаченные заказы</span>
                            </div>
                            <img :src="getPvzIcon(pickup.tk_id)" alt=""/>
                        </div>
                    </li>

                </ul>
                <div v-else>Пунктов выдачи не найдено.</div>
            </div>
            <input class="order__radio-tab" id="tab-map" type="radio" name="tab" value=""/>
            <div class="order__tab">
                <pvz-map2 v-if="this.pvz_count"
                        :lat="this.coordinates.lat"
                        :lon="this.coordinates.lon"
                        :pvz="this.pvzs"
                        :baseurl="localBaseUrl"
                        :selected_pvz="selected_pvz"
                ></pvz-map2>
            </div>
        </div>
    </div>
</template>

<script>
    import PvzMap2 from "./pvz-map2";

    export default {
        components: {PvzMap2},
        name: "pvz-select2",
        props: {
            search: {
                type: String,
                default: ''
            },
            selected: {
                type: String,
                default: '0;0'
            },
            baseurl: {
                type: String
            }
        },
        data() {
            return {
                local_search: this.search,
                selected_pvz: this.selected, // переданный в параметрах терминал в виде строки tk_id;pvz_id,
                listTabClass: 'order__tab-btn--active',
                mapTabClass: '',
                localBaseUrl:this.baseurl,
                isLoadingList: true,
                isNoPvz:false,
            }
        },
        computed: {
            pvzs() {
              return this.$store.getters.pvzs;
            },
            coordinates() {
              return this.$store.getters.coordinates;
            },
            pvz_count () {
                return this.pvzs.length;
            },
            filtered_pvz () {
                let pvz_data = this.selected_pvz.split(';');

                // выбранный пвз вверх массива
                this.pvzs.sort(function (a, b) {
                    return a.code == pvz_data[1] ? -1 : b.code == pvz_data[1] ? 1 : 0;
                });

                return this.pvzs.filter( (pvz) => {
                    return pvz.address.toLowerCase().indexOf(this.local_search.toLowerCase())>=0;
                })
            },
            currentTerminal: { // выбранный терминал в виде строки tk_id;pvz_id
                get: function() {
                    return this.$store.getters.pvz_selected
                },
                set: function(value) {
                    this.$store.commit('SET_PVZ', value)
                }
            },
            pvz_selected () { // выбранный ПВЗ в виде объекта
                let ret = {
                    name: '',
                    address: '',
                    worktime: '',
                    OnlyPrepaidOrders: '0',
                    cache: '1',
                    cost: 0
                };
                let pvz = this.$store.getters.pvz_obj_selected

                if(!!pvz) {
                    ret.name = pvz.name;
                    ret.address = pvz.address;
                    ret.worktime = 'время работы:' + pvz.worktime;
                    ret.OnlyPrepaidOrders = pvz.OnlyPrepaidOrders;
                }
                return ret
            },
        },

        methods: {
            setPvz() {
                this.$store.dispatch('setPvz', this.currentTerminal)
                    .catch(() => {})
            },
            setTab(tab) {
                if(tab==='list') {
                    this.listTabClass = 'order__tab-btn--active';
                    this.mapTabClass = '';
                } else {
                    this.listTabClass = '';
                    this.mapTabClass = 'order__tab-btn--active';
                }
            },
            getPvzIcon (tk_id) {
                let ret = this.localBaseUrl + '/img/pvz/dl24.png';
                switch (tk_id) {
                    case 2: //boxberry
                        ret = this.localBaseUrl + '/img/pvz/bb24.png';
                        break;
                    case 3: //axiomus
                        ret = this.localBaseUrl + '/img/pvz/axiomus24.png';
                        break;
                    case 4: //sdek
                        ret = this.localBaseUrl + '/img/pvz/sdek24.png';
                        break;
                }
                return ret;
            }
        },
      async mounted() {
          await this.$store.dispatch('getPvzs');
          await this.$store.dispatch('setPvz', this.selected_pvz);
          this.isLoadingList = false;

          if(this.pvzs.length === 0) {

          }
      }
    }
</script>

<style scoped>
  .terminal_selected {
    color: green;
    font-weight: normal;
  }
  .terminal_nonselected {
    color: #c8242d;
    font-weight: normal;
  }
  .list-loading {
    text-align: center;
    font-size: 18px;
  }
</style>
